class sidebarListScroll {
    constructor() {
        this.sidebarListScroll();
    }

    
    sidebarListScroll() {
        $(".sidebar_list_scroll__js a").on("click", function (e) {
            e.preventDefault();
            const href = $(this).attr("href");
            $("html, body").animate({ scrollTop: $(href).offset().top -70 }, 200);
        });
    }

   

}

new sidebarListScroll();